import { SessionService } from './../../services/session.service';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'loyale-load-dialog',
    templateUrl: './load-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoadDialogComponent implements OnInit {
  loadingImageUrl: string | null = null;
  loadingSchemeName: string | null = null;

  constructor(public sessionService: SessionService) { }

  ngOnInit() {
    this.loadingImageUrl = this.getLoadingValue('loadingSchemeImageUrl', this.sessionService.schemeImageUrl);
    this.loadingSchemeName = this.getLoadingValue('loadingSchemeName', this.sessionService.schemeName);
  }

  private getLoadingValue(key: string, fallback: string | null): string | null {
    try {
      return sessionStorage.getItem('loadingSchemeId') === this.sessionService.schemeId
        ? sessionStorage.getItem(key)
        : fallback;
    } catch {
      return fallback;
    }
  }
}
